import React from 'react';

/**
 * شارة "موثّق" للأعضاء المميزين (Premium)
 * تظهر بجانب الاسم في نتائج البحث، الرسائل، والملف الشخصي
 */

// دالة مساعدة للتحقق من حالة العضوية المميزة
export const isPremiumMember = (user) => {
  if (!user) return false;
  if (user.is_premium === true) return true;
  if (user.membership_type !== 'premium') return false;

  // التحقق من تاريخ الانتهاء
  const expires = user.membership_expires_at;
  if (!expires) return false;

  try {
    const expiresDate = new Date(expires);
    return expiresDate > new Date();
  } catch {
    return false;
  }
};

export const VerifiedBadge = ({ size = 'md', showText = false, style = {} }) => {
  const sizes = {
    sm: { icon: 14, padding: '2px 6px', fontSize: '10px', gap: '3px' },
    md: { icon: 16, padding: '3px 8px', fontSize: '11px', gap: '4px' },
    lg: { icon: 20, padding: '5px 12px', fontSize: '13px', gap: '6px' },
  };
  const s = sizes[size] || sizes.md;

  return (
    <span
      data-testid="verified-badge"
      title="عضو موثَّق · Premium Member"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: s.gap,
        background: 'linear-gradient(135deg, #1DA1F2 0%, #0E76B8 100%)',
        color: '#fff',
        padding: s.padding,
        borderRadius: '12px',
        fontSize: s.fontSize,
        fontWeight: '700',
        boxShadow: '0 2px 8px rgba(29, 161, 242, 0.35)',
        verticalAlign: 'middle',
        whiteSpace: 'nowrap',
        lineHeight: 1,
        ...style,
      }}
    >
      <svg
        width={s.icon}
        height={s.icon}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ flexShrink: 0 }}
      >
        <path
          d="M12 2L14.4 4.2L17.6 3.6L18.6 6.8L21.4 8.4L20.2 11.4L21.4 14.4L18.6 16L17.6 19.2L14.4 18.6L12 20.8L9.6 18.6L6.4 19.2L5.4 16L2.6 14.4L3.8 11.4L2.6 8.4L5.4 6.8L6.4 3.6L9.6 4.2L12 2Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="0.5"
          strokeLinejoin="round"
        />
        <path
          d="M8 12L11 15L16 9.5"
          stroke="white"
          strokeWidth="2.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      {showText && <span>موثَّق</span>}
    </span>
  );
};

export default VerifiedBadge;
